import { onUnsupportedSort } from '@/api/sortSupport'
import { t } from '@/i18n'
import { AppearanceStore } from './AppearanceStore'
import { AuthStore } from './AuthStore'
import { ChatStore } from './ChatStore'
import { LeaveGuardStore } from './LeaveGuardStore'
import { LookupStore } from './LookupStore'
import { SessionStore } from './SessionStore'
import { SettingsSyncStore } from './SettingsSyncStore'
import { ToastStore } from './ToastStore'
import { UiStore } from './UiStore'

export class RootStore {
  readonly ui = new UiStore()
  readonly appearance = new AppearanceStore()
  readonly toasts = new ToastStore()
  readonly session = new SessionStore()
  readonly leaveGuard = new LeaveGuardStore()
  readonly chat = new ChatStore()
  readonly lookups: LookupStore
  readonly settings: SettingsSyncStore
  readonly auth: AuthStore

  constructor() {
    this.lookups = new LookupStore(this)
    this.settings = new SettingsSyncStore(this)
    this.auth = new AuthStore(this)
    // A header click the backend cannot sort by yet: the list shows in its usual order instead.
    onUnsupportedSort(() => this.toasts.push({ tone: 'warning', title: t('errors.sortUnsupported'), description: t('errors.sortUnsupportedText') }))
  }
}
